<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Disciple d'Emmaus" />
            <DisciPle />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import DisciPle from '../Disciple/DisciPle.vue'

export default {
    name: 'DisciplePage',
    components: {
        NavBar,
        PageTitle,
        DisciPle,
        FooterComp,
    }
}
</script>